import { render, staticRenderFns } from "./addShopComponent.vue?vue&type=template&id=23c98270&"
import script from "./addShopComponent.vue?vue&type=script&lang=js&"
export * from "./addShopComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports